import {cn} from '../../lib/utils';
import {Icon} from '../Icon/Icon';

import type {IconName} from '../../icons/icon-map';
import type {ComponentProps, ReactNode} from 'react';

export interface PopoverButtonProps extends ComponentProps<'button'> {
  icon?: IconName;
  /** Small label rendered between the icon and the button's text — e.g. a role/admin badge. */
  badge?: ReactNode;
}

export function PopoverButton({children, icon, badge, className, ...props}: PopoverButtonProps) {
  return (
    <button
      type="button"
      data-slot="popover-button"
      className={cn(
        'flex w-full cursor-pointer items-center gap-3 rounded-sm p-2 hover:bg-background-surface_hover',
        className
      )}
      {...props}
    >
      {icon && (
        <span data-slot="icon" className="size-5 shrink-0 text-fg-tertiary">
          <Icon name={icon} />
        </span>
      )}
      {badge && (
        <span data-slot="badge" className="shrink-0 text-[10px] font-bold text-fg-quaternary">
          {badge}
        </span>
      )}
      <span className="flex-1 text-start text-sm font-semibold text-fg-secondary">{children}</span>
    </button>
  );
}
